module.exports = __webpack_public_path__ + "static/media/header-back.43760e90.jpg";